import { render, staticRenderFns } from "./ProcessingTeamModal.vue?vue&type=template&id=e2479296"
import script from "./ProcessingTeamModal.vue?vue&type=script&lang=js"
export * from "./ProcessingTeamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports